import * as React from "react";

export function Logo(props) {
   const { width, height, primaryFill = "#21201f", secondaryFill = "#c5a57f" } = props;
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         xmlnsXlink="http://www.w3.org/1999/xlink"
         width={width}
         height={height}
         viewBox="0 0 3728.404 782.638"
      >
         <path
            id="Path"
            fill={primaryFill}
            stroke="none"
            d="M115.75 659.454V345.663l116.812-118.412v432.203z"
         />
         <path
            id="path1"
            fill={primaryFill}
            stroke="none"
            d="M227.252 363.974h89.334c37.755 0 68.362-30.607 68.362-68.361s-30.607-68.362-68.362-68.362H115.75V124.775h212.12c93.397 0 169.11 75.714 169.11 169.112s-75.713 169.111-169.11 169.111H220.88Z"
         />
         <path
            id="path2"
            fill={primaryFill}
            stroke="none"
            d="M633.438 124.775V543.97h121.06V124.775Z"
         />
         <path
            id="path3"
            fill={primaryFill}
            stroke="none"
            d="M639.279 659.454h346.187V543.97H754.497Z"
         />
         <path
            id="path4"
            fill={primaryFill}
            stroke="none"
            d="m1037.5 659.454 204.952-534.679h138.554l82.326 227.783-86.547 87.078-70.618-184.244-67.432 186.368h259.64l79.645 217.694h-125.838l-42.477-112.033h-207.076l-40.884 112.033z"
         />
         <path
            id="path5"
            fill={primaryFill}
            stroke="none"
            d="M1792.528 659.454h-118.935V301.586h118.935z"
         />
         <path
            id="path6"
            fill={primaryFill}
            stroke="none"
            d="M2134.596 310.934c1.011-.884 1.895-1.895 3.032-2.778V124.72h-114.71V457.1l-207.059-332.38h-136.943l336.928 534.764h121.784v-.757c-.505-.38-1.01-.633-1.642-1.011-59.25-35.88-94.37-109.53-83.254-192.152 8.086-59.881 39.164-115.088 81.864-154.63"
         />
         <path
            id="path7"
            fill={primaryFill}
            stroke="none"
            d="M36.106 433.264c62.195-71.79 127.67-140.508 196.455-206.013-62.165 71.817-127.698 140.481-196.455 206.013"
         />
         <path
            id="path8"
            fill={primaryFill}
            stroke="none"
            d="M576.656 725.324c56.396-63.624 116.023-124.126 178.903-181.355-56.367 63.654-116.052 124.098-178.903 181.355"
         />
         <path
            id="path9"
            fill={primaryFill}
            stroke="none"
            d="M232.561 124.776c-77.503 4.533-155.057 4.574-232.561.001 77.504-4.576 155.058-4.536 232.561-.001"
         />
         <path
            id="path10"
            fill={primaryFill}
            stroke="none"
            d="M754.498 124.776c-73.787 4.533-147.626 4.574-221.412.001 73.786-4.576 147.625-4.536 221.412-.001"
         />
         <path
            id="path11"
            fill={primaryFill}
            stroke="none"
            d="M1342.273 124.776c-73.787 4.533-147.626 4.574-221.412.001 73.786-4.576 147.625-4.536 221.412-.001"
         />
         <path
            id="path12"
            fill={primaryFill}
            stroke="none"
            d="M754.498 543.97c-73.787 4.534-147.626 4.574-221.412.001 73.786-4.576 147.625-4.534 221.412 0"
         />
         <path
            id="path13"
            fill={primaryFill}
            stroke="none"
            d="M1065.642 659.455c-73.787 4.533-147.626 4.573-221.412 0 73.786-4.575 147.625-4.535 221.411 0"
         />
         <path
            id="path14"
            fill={primaryFill}
            stroke="none"
            d="M1602.418 441.76c-73.787 4.534-147.626 4.573-221.412 0 73.786-4.574 147.625-4.534 221.412 0"
         />
         <path
            id="path15"
            fill={primaryFill}
            stroke="none"
            d="M1908.278 657.862c-73.786 4.533-147.625 4.573-221.411 0 73.786-4.575 147.625-4.535 221.411 0"
         />
         <path
            id="path16"
            fill={primaryFill}
            stroke="none"
            d="M353.62 659.455c-79.096 4.533-158.242 4.573-237.34 0 79.098-4.575 158.244-4.535 237.34 0"
         />
         <path
            id="path17"
            fill={primaryFill}
            stroke="none"
            d="M232.561 179.199c-4.592-37.409-4.632-74.89 0-112.299 4.634 37.409 4.593 74.89 0 112.299"
         />
         <path
            id="path18"
            fill={primaryFill}
            stroke="none"
            d="M754.498 179.199c-4.593-37.409-4.634-74.89-.001-112.299 4.633 37.409 4.593 74.89 0 112.299"
         />
         <path
            id="path19"
            fill={primaryFill}
            stroke="none"
            d="M985.466 657.862c-4.592-64.94-4.634-129.923 0-194.863 4.633 64.94 4.592 129.922 0 194.863"
         />
         <path
            id="path20"
            fill={primaryFill}
            stroke="none"
            d="M1673.593 762.46c-4.593-64.94-4.634-129.923 0-194.863 4.633 64.94 4.592 129.923 0 194.864"
         />
         <path
            id="path21"
            fill={primaryFill}
            stroke="none"
            d="M1673.593 408.209c-4.593-64.94-4.634-129.923 0-194.863 4.633 64.94 4.592 129.923 0 194.863"
         />
         <path
            id="path22"
            fill={primaryFill}
            stroke="none"
            d="M2137.628 308.156c-1.137.883-2.021 1.894-3.032 2.778.252-62.786.758-125.069 1.643-186.213.378-29.689.884-58.997 1.389-88.054 1.642 87.17 2.653 177.497 3.032 268.835-1.011.885-2.147 1.77-3.032 2.654"
         />
         <path
            id="path23"
            fill={primaryFill}
            stroke="none"
            d="M2137.628 658.728c.505.252 1.137.631 1.642.883-.505 34.741-1.01 68.978-1.642 102.835-.631-33.857-1.137-68.22-1.642-102.96v-1.77c.631.38 1.137.632 1.642 1.012"
         />
         <path
            id="path24"
            fill={primaryFill}
            stroke="none"
            d="M1792.528 762.46c-4.592-64.94-4.633-129.923 0-194.863 4.634 64.94 4.593 129.923 0 194.864"
         />
         <path
            id="path25"
            fill={primaryFill}
            stroke="none"
            d="M1509.898 475.525C1448.952 323.683 1386.408 154.922 1333.777 0c60.98 151.828 123.454 320.615 176.12 475.525"
         />
         <path
            id="path26"
            fill={primaryFill}
            stroke="none"
            d="M1202.63 547.421c-22.969 79.88-50.197 158.328-81.768 235.217 22.93-79.893 50.234-158.313 81.767-235.217"
         />
         <path
            id="path27"
            fill={primaryFill}
            stroke="none"
            d="M1080.444 547.421c-26.098 80.029-56.404 158.475-90.995 235.217 26.059-80.042 56.441-158.46 90.995-235.217"
         />
         <path
            id="path28"
            fill={primaryFill}
            stroke="none"
            d="M2015.824 659.455c-131.598-200.091-272.286-422.77-396.39-627.597 131.63 200.07 272.255 422.79 396.39 627.597"
         />
         <g id="Group" transform="translate(-216.366 -217.09)">
            <path
               id="path29"
               fill="#fff"
               stroke="none"
               d="M2353.994 709.312c-1.516 19.203-1.516 36.51 0 52.05.505 6.821 1.39 13.264 2.527 19.454 11.243 61.777 46.49 88.053 85.021 88.053 46.743 0 98.16-38.784 116.479-99.297-6.949 51.797-2.148 16.55-9.096 68.22-37.142 28.425-75.42 40.679-110.794 40.552-30.32-.125-58.618-9.348-82.242-25.771-.632-.38-1.264-.885-1.895-1.263-.758-.506-1.39-1.011-2.021-1.516-45.733-33.858-73.147-94.75-63.419-167.138 6.821-50.407 30.194-95.38 62.282-129.364 1.01-1.138 2.02-2.148 3.158-3.285l3.032-3.032c37.773-37.268 86.285-60.008 133.786-60.134 35.5 0 70.367 12.254 99.802 40.68-6.948 51.669-2.147 16.422-9.095 68.092-2.148-60.387-43.08-99.17-89.823-99.17-54.449 0-116.731 52.553-134.544 183.939l-.38 2.274c-1.262 9.223-2.147 18.192-2.778 26.656"
            />
            <path
               id="path30"
               fill={secondaryFill}
               stroke="none"
               d="m2356.773 682.656.38-2.274c17.812-131.386 80.094-183.94 134.543-183.94 46.743 0 87.675 38.784 89.823 99.17 6.948-51.669 2.147-16.422 9.095-68.092-29.435-28.425-64.303-40.68-99.802-40.68-47.501.127-96.013 22.867-133.786 60.135l-3.032 3.032c-1.137 1.137-2.148 2.147-3.158 3.285-32.088 33.983-55.46 78.957-62.282 129.364-9.728 72.389 17.686 133.28 63.419 167.138.631.505 1.263 1.01 2.02 1.516.633.378 1.264.883 1.896 1.263 23.624 16.423 51.922 25.646 82.242 25.771 35.374.127 73.652-12.127 110.794-40.552 6.948-51.67 2.147-16.423 9.096-68.22-18.319 60.513-69.736 99.297-116.479 99.297-38.531 0-73.778-26.276-85.021-88.053-1.138-6.19-2.022-12.633-2.527-19.455-1.516-15.54-1.516-32.846 0-52.05.632-8.463 1.516-17.432 2.779-26.655"
            />
            <image
               xlinkHref="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABaADAAQAAAABAAAABQAAAAB/qhzxAAAAVklEQVQIHWP8//8/EwMDAwjDwD+WHz9+yAIlLIAijEDw+vfv3xeYgIAHyNEG0gZACUVeXl4Wlr9//3749+/fMRYWFkZmZua3QInvDECtjA0NDUwgGoYBuF8m0scKmJMAAAAASUVORK5CYII="
               id="Image-Layer"
               width="5"
               height="5"
               x="2315"
               y="727"
            />
            <path
               id="path31"
               fill={secondaryFill}
               stroke="none"
               d="M2759.268 579.569c-20.719.505-41.437 8.843-58.745 24.76l-9.095-24.76h-85.149l-1.39 9.602c29.436-.127 32.215 13.77 29.436 34.993l-28.172 209.586c-2.906 21.223-9.475 35.12-38.91 35.12l-1.264 9.474h136.313l1.39-9.6c-29.436 0-32.215-13.897-29.436-35.121l19.203-142.755c10.106-74.537 38.404-101.697 62.913-101.697 32.973 0 58.871 49.648 23.119 99.55l1.137-1.265-19.455 27.162 7.706 4.674 66.703-93.612c-18.57-31.583-47.374-46.617-76.304-46.111"
            />
            <path
               id="path32"
               fill={secondaryFill}
               stroke="none"
               d="m3036.062 833.75 19.329-142.882c8.211-61.524-34.868-111.3-96.392-111.3-37.141 0-72.389 18.193-96.265 46.112l38.531 87.043c-103.845 45.732-127.09 165.621 17.686 165.621 23.625 0 41.311-5.684 54.45-15.538l5.558 15.538h85.275l1.263-9.6c-29.309 0-32.214-13.77-29.435-34.994m-62.408-42.07c-5.811 42.575-29.688 77.19-53.565 77.19-28.045 0-39.037-25.014-35.626-55.46 5.18-47.501 44.596-108.393 100.813-108.393zm13.517-100.812-.631 4.547c-28.047 0-53.692 5.054-75.926 13.518l-8.843-20.213c-24.13-54.197 17.813-99.676 55.965-99.676 23.877 0 37.015 45.48 29.435 101.824"
            />
            <path
               id="path33"
               fill={secondaryFill}
               stroke="none"
               d="m3136.749 573.221-.84 6.246h-34.083l-1.29 9.58h34.083l-32.934 244.703c-2.85 21.174-9.437 35.061-38.801 35.061l-1.29 9.58h136.268l1.298-9.646c-29.364 0-32.213-13.887-29.363-35.062l32.925-244.636h34.082l1.29-9.58h-34.083l.84-6.246c22.044-163.785 126.837-97.748 72.59-9.87l7.709 5.32c17.88-25.051 23.01-31.975 43.362-60.634-57.06-96.98-179.589-25.272-191.763 65.184"
            />
            <path
               id="path34"
               fill={secondaryFill}
               stroke="none"
               d="m3421.13 588.964 1.289-9.58h-45.124l12.464-92.605h-9.651c-1.05 9.857-16.982 41.585-66.245 57.41l-4.746 35.262h-93.725l-1.29 9.58h93.726l-23.918 177.713c-13.772 102.329 34.227 110.867 98.371 110.867l1.411-10.487c-25.758 0-44.917-1.528-31.613-100.38l23.927-177.78z"
            />
            <path
               id="path35"
               fill={secondaryFill}
               stroke="none"
               d="M3650.163 667.37c8.59-61.019-36.132-89.696-89.57-87.927-65.819 2.147-145.03 51.164-158.295 149.45-11.116 82.495 48.766 149.451 133.787 149.451 31.71 0 62.534-9.348 89.191-25.392 5.558-41.31 3.537-26.783 9.096-68.093-4.55 33.604-51.671 83.885-97.024 83.885-46.365 0-76.05-60.008-67.461-135.05 55.585 0 169.537 11.244 180.276-66.324m-95.255-78.2c20.845.884 33.1 33.604 29.057 63.798-4.549 34.362-35.5 71.125-112.815 71.125 21.982-97.023 59.504-136.186 83.758-134.922"
            />
            <path
               id="path36"
               fill={secondaryFill}
               stroke="none"
               d="m3894.742 833.623 50.027-371.29h-102.328l-1.265 9.474c29.31 0 32.215 13.897 29.31 35.12l-12.76 94.877c-11.495-14.15-28.424-22.361-52.3-22.361-68.221 0-132.522 66.956-143.641 149.45-10.99 82.622 35.247 149.451 103.467 149.451 26.15 0 46.617-9.853 62.66-26.53l9.728 26.53h85.148l1.263-9.6c-29.309 0-32.216-13.897-29.309-35.121m-54.07-104.73c-10.359 77.316-43.586 139.976-74.157 139.976-30.572 0-46.995-62.786-36.637-139.975 10.485-77.19 43.712-139.85 74.284-139.85s46.995 62.66 36.51 139.85"
            />
         </g>
      </svg>
   );
}
